import ChevronRightIcon from '../Icons/ChevronRight.icon';
import BadgeComponent from '../Badge.component';
import React, { FC } from 'react';
import styled from 'styled-components';

const StyledAttachmentsHistoryBlockWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 5px;
  font-weight: 500;
`;

interface AttachmentsHistoryBlockProps {
  url: string;
  type: string;
  appearance: 'default' | 'primary' | 'warning' | 'success' | 'danger';
}

const AttachmentsHistoryBlock: FC<AttachmentsHistoryBlockProps> = ({
  url,
  type,
  appearance,
}) => (
  <StyledAttachmentsHistoryBlockWrapper key={url}>
    <span>{type}</span>
    <ChevronRightIcon />
    <BadgeComponent
      textTransform="lowercase"
      appearance={appearance}
      text={url}
    />
  </StyledAttachmentsHistoryBlockWrapper>
);

export default AttachmentsHistoryBlock;
